import $ from 'jquery';

export default function getCart() {
  return $.get('/ajax/cart').then(res => res.cart);
}
